import { fetchPlayers } from '@api-service/players';
import type { Player as FfhPlayer } from '@api-service/players';

export const getSearch = async (
  keyword: string,
  accessToken?: string
): Promise<FfhPlayer[]> => {
  // Anonymous /league/players calls must opt out of predictions; the API
  // rejects unauthenticated prediction enrichment with PREDICTIONS_REQUIRE_AUTH
  // (400), which left the Player Profile search unusable when logged out.
  const response = await fetchPlayers({
    search: keyword,
    limit: 25,
    ...(accessToken ? { accessToken } : { exclude: 'predictions' })
  });
  return response.data;
};
